// -*- Mode: rjsx -*-
import React from 'react';

import { createTheme, adaptV4Theme, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';
import { purple, blue, lightBlue, red, pink, teal, green, yellow, lightGreen } from '@mui/material/colors';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import makeStyles from '@mui/styles/makeStyles';

import Color from 'color';

const FH_LOGO_HEIGHT = 48;/* this is used in this file and ui/FancyHandsLogo.js */

const FHTheme = createTheme(adaptV4Theme({
    palette: {
        background: { default: "#f5f5f5" },

        primary: { main: lightBlue[700] }, // "#3c3846" }, //
        secondary: { main: "#c02330" },
        //  primary: blue,
        // secondary: lightgreen,

        // our custom colors colors
        money: green[700], // "#73a28a",

        queueAvailable: teal[100], //
        queueMentor: lightGreen[200],
        queueAssigned: blue[100],
        queueCall: pink[50],        
                
    },
    typography: {
        // In Chinese and Japanese the characters are usually larger,
        // so a smaller fontsize may be appropriate.
        fontSize: 14,
    },

    overrides: {
        MuiCssBaseline: {
            '@global': {
                html: {
                    WebkitFontSmoothing: 'auto',
                },
            },
        },        
        // Style sheet name ⚛️
        MuiCard: {
            // Name of the rule
            root: {
                // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                background: 'white', // linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',                                
            }
        },
    },    
    
}));

const FHMaterialStyles = makeStyles((theme) => ({

	root: {
		height: '100vh',
        backgroundColor: "white", // theme.palette.background,
        //        color: "black"
        
	},

    toolbar: theme.mixins.toolbar,
    
	assistantRoot: {
		height: '100vh',
        backgroundColor: theme.palette.background,
        width: "100%"
	},
    
    
    fullWidth: {
        width: "100%",
        border: "solid 1px red"
    },
	sidebarFullImage: {
		backgroundColor:
		theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        background: "linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.8)), url(/images/hilly-bkg.jpg)",

		backgroundRepeat: 'no-repeat',
        
		backgroundSize: 'cover',
		backgroundPosition: '20%',
	},

	paper: {
		margin: theme.spacing(8, 4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
    fancyTextInput: {
        resize: 'none',
        width: "100%",
        height: 90,
        border: "1px solid #DADADA",
        lineHeight: 1.75,
        fontSize: "18px",
        whiteSpace: "pre-wrap",
        padding:  "14px 20px",
        color: "#2f3237",
        overflow: "auto",
        fontFamily: "Arial, sans-serif",
        fontWeight: "400",
        "-webkit-font-smoothing": "antialiased",
        outline: "none",
        // borderRadius: 5
    },
    
    fancyTextInputHeader: {
        border: "1px solid #DADADA",
        borderBottom: "0px",        
        padding:  "14px 20px",
        color: "#2f3237",
        fontFamily: "Arial, sans-serif",
        fontWeight: "400",
        "-webkit-font-smoothing": "antialiased",        
        lineHeight: 1.75,        
        fontSize: '18px'
    },
    fancyTextInputFooter: {
        border: "1px solid #DADADA",
        borderTop: "0px",        
        padding:  "14px 20px",
        color: "#2f3237",
        fontFamily: "Arial, sans-serif",
        fontWeight: "400",
        "-webkit-font-smoothing": "antialiased",        
        lineHeight: 1.75,        
        fontSize: '18px'
    },
    
    suggestion: {
        borderBottom: "solid 3px red",
        backgroundColor: "orange",
        fontWeight: "bold",
        color: "green"
    },
    correctionsPopup: {
        backgroundColor: "white",
        padding: 16,
        borderRadius: 6,
        position: "absolute",
        border: "solid 1px lightgrey",
        boxShadow: "2px 2px 10px grey",
        display: "hidden",
        zIndex: 999999
    },
    chips: {
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },


    
    adminMainContainer: {
        margin: 0, // theme.spacing(3),        
//        backgroundColor: "#ffffff",
    },
    
    adminLogoStyle: {
        display: "block",
        maxHeight: FH_LOGO_HEIGHT, 
        minHeight: FH_LOGO_HEIGHT,
        width: "auto",
        height: "auto"        
    },
    adminHeader: {
        height:  64,
        backgroundColor: "#f2f2f2",
        boxShadow: "0px 1px 5px -2px #000000",
        paddingLeft: 16,
        paddingRight: 8,
        marginBottom: 0
    },

    adminUserMenuItem: {
        color: "black",
    },
    

    qNavLunch: {
        fontSize: 10,
        color: "grey"
    },
        
    qNav: {
        cursor: "pointer",
        padding: 16,
        height: 56,
        width: "100%",
//        width: 175,        
        borderBottom: "solid 1px #ddd",
        borderTop: "solid 1px #f7f7f7",
        display: "block",
        backgroundColor: "#f2f2f2",
        color: "black",        
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',

        textTransform: "uppercase",
        "& span": {
            paddingLeft: 8,
            paddingRight: 8
        }
      
    },
    qNavActive: {
        borderTop: "solid 1px #fefefe",                
        color: "black",
        backgroundColor: "#fefefe"
    },

    /* active links in admin queue */
    qNavFirst: {
        borderTop: "0px !important",                
    },    


    
    adminContentContainer: {
        
    },

    settingsFormControl: {
        margin: theme.spacing(1)
    },


    adminSidebar: {
        border: "solid 1px black",
        borderRadius: 5,
        width: "100%"
    },

    assistantSidebarCard: {
        backgroundColor: "white"
    },

    adminRequestHeaderContainer: {
        marginBottom: theme.spacing(1)
    },

    adminRequestBodyContainer: {
//        margin: 32, // theme.spacing(1),
//        backgroundColor: "red",
    },


    loadingContainer: ({color}) => {
        return { 
            position: "",
            top: 0,
            left: 0,
            width: "100%",
		    height: '100vh',        
            display: "flex",
            background: `linear-gradient(-45deg, ${Color(color).lighten(0.9)}, ${Color(color).lighten(0.7)}, ${Color(color).lighten(0.6)}, ${Color(color).lighten(0.5)}) !important;`,
	        animation: "linear-gradient 1s ease infinite !important"
        };
    },



    loadingCard: ({color}) => {
        return {
            margin: "auto",
            marginTop: "10% !important",
            minWidth: 256,
            borderRadius: 8,
            boxShadow: `0 6px 12px 0 ${Color(color)
        .rotate(-12)
        .darken(0.2)
        .fade(0.5)}`,
        };
    },

    loadingContent: ({ color }) => {
        return {
            backgroundColor: `${Color(color).darken(0.1)}`,
            // background: `linear-gradient(-45deg, ${Color(color).lighten(0.9)}, ${Color(color).lighten(0.6)}, ${Color(color).lighten(0.4)}, ${Color(color)}) !important;`,
           color: "white",

            textShadow: `1px 1px ${Color(color).darken(0.2)}`,
            borderRadius: 8,
            padding: '1rem 1.5rem 1.5rem',
        };
    },
    
    celebrateContainer: ({color}) => {
        return { 
            position: "",
            top: 0,
            left: 0,
            width: "100%",
		    height: '100vh',        
            display: "flex",
            background: `linear-gradient(-45deg, ${Color(color).lighten(0.9)}, ${Color(color).lighten(0.6)}, ${Color(color).lighten(0.4)}, ${Color(color)}) !important;`,
	        animation: "linear-gradient 1s ease infinite !important"
        };
    },

    celebrateCard: ({color}) => {
        return {
            margin: "auto",
            marginTop: "10% !important",
            minWidth: 256,
            borderRadius: 8,
            boxShadow: 'none',
            '&:hover': {
                boxShadow: `0 6px 12px 0 ${Color(color)
        .rotate(-12)
        .darken(0.2)
        .fade(0.5)}`,
            },
        };
    },
    
    celebrateContent: ({ color }) => {
        return {
            backgroundColor: color,
            padding: '1rem 1.5rem 1.5rem',
        };
    },

    celebrateMedia:  ({ color }) => {
        return {
            height: 350,
            width: "100%",
            backgroundColor: `${ Color(color).darken(0.4) }`
        };
    },    
    
  celebrateActionArea: {
      borderRadius: 16,
      transition: '0.2s',
      '&:hover': {
          transform: 'scale(1.1)',
      },
  },    


    celebrateTitle: {
        fontSize: '2rem',
        color: '#fff',
//        textTransform: 'uppercase',
    },
    
    celebrateSubtitle: {
        color: '#fff',
        opacity: 0.87,
        marginTop: '2rem',
        fontWeight: 500,
        fontSize: 14,
    },


    queueOptionContainer: {
        margin: 32,
        padding: 32,
        backgroundColor: "white"
    },

    queueOptionMetaContainer: ({color}) => {
        return {
            color: "white",
            padding: 16,
            backgroundColor: `${ Color(color).darken(0.3) }`,
            borderRight: `solid 1px ${ Color(color).darken(0.6) }`
        };
    },
    
    queueOptionEntityContainer: ({color}) => {
        return {
            padding: 16,
            backgroundColor: color,
            color: 'black',
            borderLeft: `solid 3px ${ Color(color).darken(0.6) }`
        };
    },


    queueOptionActionArea: {
        transition: '0.2s',
        // '&:hover': {
        //     transform: 'scale(1.02)',
        //     // transform: 'rotate3d(1.0, 1, 1, 1deg)' // scale3d(1.3, 1.0, 0.8)',
        // },
        '&:active': {
            //transform: 'scale(1.03)',
            transform: 'scale(1.03)' // scale3d(1.3, 1.0, 0.8)',
        },        
    },


    hudContainer: {
        backgroundColor: `${ Color(theme.palette.primary.main).lighten(0.4) }`,

        borderTop: `solid 1px ${ Color(theme.palette.primary.main).darken(0.1) }`,
        borderLeft: `solid 1px ${ Color(theme.palette.primary.main).darken(0.1) }`,
        borderRight: `solid 1px ${ Color(theme.palette.primary.main).lighten(0.35) }`,
        borderBottom: `solid 1px ${ Color(theme.palette.primary.main).lighten(0.35) }`,
        
        color: `${ Color(theme.palette.primary.text)}`,
        borderRadius: 3,
        height: theme.mixins.toolbar.minHeight,
        marginLeft: 16,
    },


    hudBarQueueSize: {
        textShadow: `1px 1px 3px ${ Color(theme.palette.primary.main).darken(0.1) }`,
        color: '#f2f2f2',
        padding: '3px',
        borderRadius: "3px",
        backgroundColor: `${ Color(theme.palette.primary.main).lighten(0.2) }`
    },

    moneyContainer: {
        color: theme.palette.money,
        borderRadius: 5,
        paddingLeft: 8,
        paddingRight: 8,
        border: `solid 1px ${Color(theme.palette.money).lighten(0.3)}`,
        background: `linear-gradient(135deg, ${Color(theme.palette.money).lighten(0.9)}, ${Color(theme.palette.money).lighten(0.8)}, ${Color(theme.palette.money).lighten(0.7)} ) !important;`,
        '&:hover': { 
            background: `linear-gradient(135deg, ${Color(theme.palette.money).lighten(0.95)}, ${Color(theme.palette.money).lighten(0.85)}, ${Color(theme.palette.money).lighten(0.75)} ) !important;`,
        },

	    // backgroundSize: "400% 400% !important",        
    },

    moneyText: {
        textShadow: `1px 1px ${Color(theme.palette.money).lighten(0.9)}}`
    }
    
}));


const FHSideContainer = (props) => {
    const classes = FHMaterialStyles();
	
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={FHTheme}>
              <Grid container component="main" className={classes.root}>
                <Grid item xs={false} sm={4} md={7} className={classes.sidebarFullImage} />
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={1} square style={{ backgroundColor: "white" }}>
                  <div className={classes.paper}>
                    {props.children}
                  </div>
                </Grid>
              </Grid>
            </ThemeProvider>
        </StyledEngineProvider>
    );


};


export { FHSideContainer, FHMaterialStyles, FH_LOGO_HEIGHT, FHTheme };
